import type { WebsiteContent } from "@/lib/website/content";

export default function PublishedSections({ content }: { content?: WebsiteContent | null }) {
  if (!content) return null;
  return <div className="container py-10 space-y-10">
    {content.sections.map((section, i) => <section key={i} className="max-w-4xl">
      <h2 className="font-display text-2xl font-semibold">{section.heading}</h2>
      <p className="mt-4 whitespace-pre-line leading-relaxed text-muted-foreground">{section.body}</p>
    </section>)}
  </div>;
}